<table
  matSort
  mat-table
  multiTemplateDataRows
  [dataSource]="machines"
  (matSortChange)="sortData($event)"
>
  <ng-container
    matColumnDef="{{ column }}"
    class="main"
    *ngFor="let column of columnsToDisplay"
  >
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header="{{ column }}"
      [disabled]="column === '#'"
    >
      <span class="item-head" *ngIf="column !== 'power'">
        {{
          columnsHeadLabels.get(column) ? columnsHeadLabels.get(column) : column
        }}
      </span>
      <span class="item-head-energy" *ngIf="column === 'power'">
        {{
          columnsHeadLabels.get(column) ? columnsHeadLabels.get(column) : column
        }}
        🔋
      </span>
    </th>
    <td mat-cell *matCellDef="let element" class="">
      <div style="display: flex; justify-content: center">
        <mat-icon
          class="item-icon"
          matTooltip="Energy consumption value computed on a statistical basis"
          *ngIf="
            column === 'power' &&
            element['powerAlgorithm'] === 'STATISTICAL_METHOD'
          "
          >insights
        </mat-icon>
        <mat-icon
          class="item-icon"
          matTooltip="Energy computed consumption value through real data"
          *ngIf="
            column === 'power' &&
            element['powerAlgorithm'] === 'POLLING_DETECTION'
          "
        >
          troubleshoot
        </mat-icon>
        <input
          type="text"
          class="item"
          [ngClass]="{
            item__run: column === 'state' && element[column] === 'RUN',
            item__err: column === 'state' && element[column] === 'ERR',
            item__off: column === 'state' && element[column] === 'OFF',
            item__stop: column === 'state' && element[column] === 'STOP',
            item__isState: column === 'state',
            item__isStateDescription: column === 'stateDescription',
            item__isMachineName: column === 'name'
          }"
          *ngIf="
            element[column] && column !== 'power'
          "
          value="{{ element[column] }}"
          disabled
        />
        <input
          type="text"
          class="item"
          [ngClass]="{
            item__power: column === 'power'
          }"
          *ngIf="
            (column === 'power' && element[column] !== undefined)
          "
          value="{{ element[column] | number:'1.2-2' }}"
          disabled
        />
        <span
          class="material-icons expand"
          *ngIf="column === '#' && element !== expandedElement"
        >
          expand_more
        </span>
        <span
          class="material-icons expand"
          *ngIf="column === '#' && element === expandedElement"
        >
          expand_less
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="columnsToDisplay.length"
    >
      <div
        class="machine-details-wrapper"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="machine-details">
          <div *ngIf="element.state" [ngSwitch]="element.state">
            <b>State:</b>
            <span *ngSwitchCase="'OFF'"> Machine is off</span>
            <span *ngSwitchCase="'RUN'"> Machine is working</span>
            <span *ngSwitchCase="'ERR'"> Machine is in error</span>
            <span *ngSwitchCase="'STOP'">Machine is on but not working</span>
            &nbsp;&nbsp;
            <b>Current work:</b>
            <span> {{ element.stateDescription }}</span>
          </div>
          <app-machine-daily-works
            [machineId]="element.id"
          ></app-machine-daily-works>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplay"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="detail-row"
  ></tr>
</table>
